<script>
import ContaAzul from "@/components/tools/modals/ContaAzul.vue";
import IntegrationList from "../IntegrationList.vue";
export default {
  extends: IntegrationList,
  data() {
    return {
      name: "Conta Azul",
      integration: "conta-azul",

      modal: ContaAzul,
      columns: [
        { name: "Produto", field: "product_name" },
        {
          name: "Código do produto",
          field: "ca_product_code"
        },
        {
          name: "Status",
          field: "status",
          type: "tag",
          transform: this.formatStatus,
          color: this.formatStatusColor,
          size: "0.5fr"
        },
        {
          name: "",
          type: "menu",
          options: this.getActions
        }
      ]
    };
  },
  methods: {
    authorizeProduct(item) {
      window.open(item.auth_url, "_blank");
    },
    getActions(item) {
      return [
        {
          label: "Editar",
          icon: "fa-light fa-pen",
          click: this.editIntegration
        },
        {
          label: "Autorizar produto na plataforma",
          color: "positive",
          icon: "fa-light fa-check",
          click: this.authorizeProduct
        },
        {
          label: item.status ? "Desativar" : "Ativar",
          color: item.status ? "negative" : "positive",
          icon: "fa-light fa-power-off",
          click: this.changeStatus
        },
        {
          label: "Excluir",
          color: "negative",
          icon: "fa-light fa-trash",
          dialog: {
            variant: "negative",
            enable: true,
            text: "Deseja mesmo remover esta integração?",
            icon: "fa fa-hexagon-exclamation",
            secondaryAction: this.deleteIntegration,
            buttonText: "Cancelar",
            secondaryButtonText: "Confirmar"
          }
        }
      ];
    }
  }
};
</script>
